import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {LayoutScrollTopComponent} from './scroll-top/scroll-top.component';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";
import { QuickLinksInnerComponent } from './quick-links-inner/quick-links-inner.component';
import { KeeniconComponent } from 'src/app/_metronic/layout/components/keenicon/keenicon.component';

@NgModule({
  declarations: [
    LayoutScrollTopComponent,
    QuickLinksInnerComponent
  ],
  imports: [CommonModule, FormsModule, InlineSVGModule, RouterModule, NgbTooltipModule , KeeniconComponent],
  exports: [
    LayoutScrollTopComponent,
    QuickLinksInnerComponent,
  ],
})
export class ExtrasModule {
}
